/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared';
import {
  TGetTagsModel,
  IGetTagsRequest,
  IMappers,
  IGetTagsResponse,
  IGetTagsResponseError,
  TGetTagsResponse,
} from './types';

const defaultConfig: TGetTagsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'journal',
  pathApi: '/v1/get-tags/',
  hostType: 'api',
} as TGetTagsModel;

function createGetTagsModel(parameters: IGetTagsRequest): TGetTagsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetTagsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetTagsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetTags<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetTagsOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetTagsResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetTagsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetTagsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetTagsResponseError);
    }
  }

  return { response, statusCode } as TGetTagsResponse;
}

export { defaultConfig, createGetTagsModel, fetchGetTags };
